/* ============================================================
 * Brindle Calm BR02 — Sales page script
 * Bundle selector + AJAX cart + sticky reveal + FAQ accordion.
 * All ATC buttons (Hero, Sticky, Bundles section) use the same
 * addVariantToCart() pipeline → POST /cart/add.js → GET /cart.js
 * → dispatch theme 'cart:update' → open cart-drawer-component.
 * ============================================================ */
(function () {
  'use strict';
  if (window.__brindleCalmBR02Loaded) return;
  window.__brindleCalmBR02Loaded = true;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function money(cents, fallback) {
    if (cents == null && fallback) return fallback;
    var n = (cents || 0) / 100;
    if (n === Math.floor(n)) return '£' + n;
    return '£' + n.toFixed(2);
  }

  /* ===== OPEN CART DRAWER (theme-aware) ===========================
   * 1) Dispatch the theme's own 'cart:update' CustomEvent so
   *    <cart-drawer-component>, <header-actions>, cart bubble,
   *    free-shipping bars, etc. refresh themselves.
   * 2) Force the drawer to open via the component's showDialog()
   *    (auto-open theme setting may be off — we override it).
   * 3) Fallbacks: click any cart trigger; otherwise hit /cart.
   * ============================================================= */
  function openCartDrawer(cartJson) {
    /* ----- 1) Refresh signals: tell every cart system the cart changed ----- */
    var refreshEvents = [
      'cart:update',          // Horizon/Dawn theme
      'cart:updated',
      'cart:refresh',
      'cart:added',
      'cart-update',
      'upcart:cart-updated',  // UpCart
      'upcart:refresh',
      'rebuy:cart-updated',
      'bold-cart:updated'
    ];
    refreshEvents.forEach(function (name) {
      try {
        var ev = new CustomEvent(name, {
          bubbles: true,
          detail: { resource: cartJson || {}, sourceId: 'bcbr02-atc', data: { source: 'brindle-calm-br02', itemCount: cartJson && cartJson.item_count } }
        });
        document.dispatchEvent(ev);
        window.dispatchEvent(ev);
      } catch (e) {}
    });

    /* ----- 2) UpCart drawer (this is what the store actually uses) ----- */
    try { if (window.UPCART && typeof window.UPCART.openCart === 'function') { window.UPCART.openCart(); return; } } catch (e) {}
    try { if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return; } } catch (e) {}
    try { if (window.upcart && typeof window.upcart.open === 'function')     { window.upcart.open();     return; } } catch (e) {}

    // Dispatch the explicit UpCart open event (UpCart listens to this)
    try {
      var upcartOpen = new CustomEvent('upcart:open', { bubbles: true });
      document.dispatchEvent(upcartOpen);
      window.dispatchEvent(upcartOpen);
    } catch (e) {}

    // Click any UpCart trigger node that the app renders
    var upcartTrigger = document.querySelector('#upcart-trigger, .upcart-trigger, [data-upcart-trigger], #upcart-floating-button, .upcart-floating-button, [aria-label="Open cart"][data-source="upcart"]');
    if (upcartTrigger) { try { upcartTrigger.click(); return; } catch (e) {} }

    /* ----- 3) Native theme drawer (cart-drawer-component) ----- */
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      if (typeof drawer.showDialog === 'function') {
        try { drawer.showDialog(); return; } catch (e) {}
      }
      var dlg = drawer.querySelector('dialog');
      if (dlg && typeof dlg.showModal === 'function') {
        try { dlg.showModal(); return; } catch (e) {}
      }
    }
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) { try { trigger.click(); return; } catch (e) {} }

    /* ----- 4) Legacy / generic ----- */
    var legacy = document.querySelectorAll('[data-cart-drawer-trigger], .cart-icon-bubble, .header__cart-link, cart-drawer-icon, [data-action="open-cart"]');
    if (legacy.length) { try { legacy[0].click(); return; } catch (e) {} }
  }

  /* ===== UNIFIED ADD-TO-CART =====================================
   * Used by every ATC entry point on the page.
   * ============================================================= */
  function addVariantToCart(variantId, qty, button) {
    // No variant configured → log + scroll to the offer band as a last resort
    if (!variantId) {
      console.warn('[bcbr02] Add-to-cart ignored: no variant id is attached to this button. The Hero section needs a Linked product picked in theme editor, OR the bundle block needs a Variant position / Variant ID set.');
      var offer = document.getElementById('bcbr02-offer');
      if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    if (button) { button.disabled = true; button.classList.add('is-loading'); }

    var body = { items: [{ id: parseInt(variantId, 10) || variantId, quantity: qty || 1 }] };

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (button) { button.disabled = false; button.classList.remove('is-loading'); }
          // Surface the error message if Shopify returned one
          console.warn('[bcbr02] /cart/add.js failed:', res.body);
          return;
        }
        // Fetch the up-to-date cart, then dispatch theme event + open drawer
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (button) { button.disabled = false; button.classList.remove('is-loading'); }
            openCartDrawer(cart);
          });
      })
      .catch(function (err) {
        if (button) { button.disabled = false; button.classList.remove('is-loading'); }
        console.warn('[bcbr02] add to cart error:', err);
      });
  }

  function init() {
    var root = $('.bcbr02-scope');
    if (!root) return;

    /* ---------- Bundle selector (Hero radio cards) ---------- */
    var sels = $$('.bcbr02-sel');

    /* Debug: show what we found so the seller can see misconfig fast */
    try {
      var wired = sels.filter(function (s) { return !!s.getAttribute('data-bcbr02-variant'); });
      console.info('[bcbr02] hero bundle cards: ' + sels.length + ', wired with variant id: ' + wired.length);
      if (sels.length > 0 && wired.length === 0) {
        console.warn('[bcbr02] No bundle card has a variant id. Open the Hero section in theme editor, pick the Linked product, and (optionally) set Variant position 1/2/3 on each block.');
      }
    } catch (e) {}
    var atc = $('[data-bcbr02-atc]');
    var stName = $('[data-bcbr02-sticky-name]');
    var stPrice = $('[data-bcbr02-sticky-price]');
    var selectedVariantId = null;
    var selectedTier = null;

    function selectBundle(el) {
      if (!el) return;
      sels.forEach(function (s) { s.classList.remove('is-selected'); });
      el.classList.add('is-selected');
      selectedVariantId = el.getAttribute('data-bcbr02-variant') || null;
      selectedTier = el.getAttribute('data-bcbr02-tier') || '';
      var priceDisplay = el.querySelector('.bcbr02-sel__price');
      var priceText = priceDisplay ? priceDisplay.textContent.trim() : '';
      if (atc) {
        var lbl = atc.querySelector('[data-bcbr02-atc-label]') || atc;
        lbl.textContent = 'Add to cart — ' + priceText;
      }
      if (stName) stName.textContent = 'Brindle Calm — ' + selectedTier;
      if (stPrice) stPrice.textContent = priceText;
    }

    sels.forEach(function (s) {
      s.addEventListener('click', function () { selectBundle(s); });
    });
    var initialSel = $('.bcbr02-sel.is-selected') || sels[0];
    if (initialSel) selectBundle(initialSel);

    /* ---------- Post-init: honour ?variant=<id> from URL (deep-link from advertorial) ----------
       Runs AFTER the default selection is wired, so if anything goes wrong here the
       selectors still work normally. We just simulate a click on the matching card. */
    try {
      var urlVariant = (new URLSearchParams(window.location.search)).get('variant');
      if (urlVariant && sels.length) {
        var match = null;
        for (var i = 0; i < sels.length; i++) {
          if (sels[i].getAttribute('data-bcbr02-variant') === urlVariant) {
            match = sels[i];
            break;
          }
        }
        if (match && match !== initialSel) {
          selectBundle(match);
          console.info('[bcbr02] hero preselected from URL variant=' + urlVariant);
        }
      }
    } catch (e) { /* never break the page */ }

    /* ---------- Hero ATC ---------- */
    if (atc) {
      atc.addEventListener('click', function (e) {
        e.preventDefault();
        addVariantToCart(selectedVariantId, 1, atc);
      });
    }

    /* ---------- Sticky bar ATC ---------- */
    var stickyBtn = $('[data-bcbr02-sticky-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addVariantToCart(selectedVariantId, 1, stickyBtn);
      });
    }

    /* ---------- Bundles section: selector cards + ATC buttons ---------- */
    var bundleCards = $$('[data-bcbr02-bundle-card]');

    function highlightBundleCard(card) {
      bundleCards.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      if (card) {
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
      }
    }

    function syncHeroFromCard(card) {
      if (!card) return;
      var vid = card.getAttribute('data-bcbr02-variant');
      var tier = card.getAttribute('data-bcbr02-tier');
      // Try variant id first, fall back to tier name match
      var matching = null;
      if (vid) {
        matching = sels.find(function (s) { return s.getAttribute('data-bcbr02-variant') === vid; });
      }
      if (!matching && tier) {
        matching = sels.find(function (s) { return (s.getAttribute('data-bcbr02-tier') || '').toLowerCase() === tier.toLowerCase(); });
      }
      if (matching) selectBundle(matching);
    }

    function syncCardFromHero(heroSel) {
      if (!heroSel) return;
      var vid = heroSel.getAttribute('data-bcbr02-variant');
      var tier = heroSel.getAttribute('data-bcbr02-tier');
      var matching = null;
      if (vid) {
        matching = bundleCards.find(function (c) { return c.getAttribute('data-bcbr02-variant') === vid; });
      }
      if (!matching && tier) {
        matching = bundleCards.find(function (c) { return (c.getAttribute('data-bcbr02-tier') || '').toLowerCase() === tier.toLowerCase(); });
      }
      if (matching) highlightBundleCard(matching);
    }

    // Click on a bundle CARD selects it and propagates choice to Hero selector
    bundleCards.forEach(function (card) {
      function handleCardSelect(e) {
        // Don't intercept clicks on the inner ATC button — it has its own handler below
        if (e && e.target && (e.target.closest && e.target.closest('[data-bcbr02-bundle-atc]'))) return;
        highlightBundleCard(card);
        syncHeroFromCard(card);
      }
      card.addEventListener('click', handleCardSelect);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleCardSelect(e); }
      });
    });

    // Hero radio click → also sync the corresponding bundle card highlight
    sels.forEach(function (s) {
      s.addEventListener('click', function () { syncCardFromHero(s); });
    });
    // Initial sync (in case the user lands on the page with a hero default already chosen)
    var initialHero = $('.bcbr02-sel.is-selected') || sels[0];
    if (initialHero) syncCardFromHero(initialHero);

    // ATC button on each bundle card: select + add to cart + open UpCart
    $$('[data-bcbr02-bundle-atc]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = a.closest('[data-bcbr02-bundle-card]');
        if (card) { highlightBundleCard(card); syncHeroFromCard(card); }
        var vid = a.getAttribute('data-bcbr02-variant');
        if (vid) {
          addVariantToCart(vid, 1, a);
        } else {
          var offer = $('#bcbr02-offer');
          if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    /* ---------- Sticky cart reveal ---------- */
    var sticky = $('.bcbr02-sticky');
    var hero = $('.bcbr02-hero');
    function updateSticky() {
      if (!sticky || !hero) return;
      var pastHero = (hero.offsetTop + hero.offsetHeight);
      if (window.scrollY > pastHero) sticky.classList.add('is-shown');
      else sticky.classList.remove('is-shown');
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();

    /* ---------- FAQ accordion ---------- */
    $$('.bcbr02-faq-q').forEach(function (q) {
      var a = q.nextElementSibling;
      var item = q.parentElement;
      if (item.classList.contains('is-open') && a) {
        a.style.maxHeight = a.scrollHeight + 'px';
      }
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        $$('.bcbr02-faq-item').forEach(function (i) {
          i.classList.remove('is-open');
          var body = i.querySelector('.bcbr02-faq-a');
          if (body) body.style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('is-open');
          if (a) a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });

    /* ---------- Modern gallery slider ----------
       - Click thumb → scroll slider to that index
       - Arrow click → scrollBy viewport width
       - IntersectionObserver keeps active thumb in sync as user swipes/scrolls
    */
    var slider = $('[data-bcbr02-gallery-slider]');
    var thumbs = $$('[data-bcbr02-gallery-thumb]');
    var slides = $$('[data-bcbr02-gallery-slide]');
    var prevBtn = $('[data-bcbr02-gallery-prev]');
    var nextBtn = $('[data-bcbr02-gallery-next]');

    function setActiveThumb(idx) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      var match = thumbs.find(function (t) { return t.getAttribute('data-bcbr02-gallery-thumb') === String(idx); });
      if (match) {
        match.classList.add('is-active');
        // Keep the active thumb in the thumb strip view
        try { match.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' }); } catch (e) {}
      }
    }

    function scrollToIndex(idx) {
      if (!slider) return;
      var slide = slider.querySelector('[data-bcbr02-gallery-slide="' + idx + '"]');
      if (!slide) return;
      slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = parseInt(t.getAttribute('data-bcbr02-gallery-thumb'), 10);
        setActiveThumb(idx);
        scrollToIndex(idx);
      });
    });

    if (prevBtn && slider) {
      prevBtn.addEventListener('click', function () { slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' }); });
    }
    if (nextBtn && slider) {
      nextBtn.addEventListener('click', function () { slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' }); });
    }

    // Keep active thumb in sync with the slide currently in view
    if (slider && slides.length > 1 && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            var idx = parseInt(e.target.getAttribute('data-bcbr02-gallery-slide'), 10);
            if (!isNaN(idx)) setActiveThumb(idx);
          }
        });
      }, { root: slider, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
